import React, { Fragment } from 'react';
import P from './P.jsx';

const Col = (props) => {
    return (
        <div className="col">
            {props.detalle.map((x,i) => <P key={i} clase={x.clase} valor={x.valor} />)}
        </div>
    );
}

export default Col;